import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/landing",
    component: () => import("./views/ceur/CeurLayoutPublicNoMenu.vue"),
    children: [
      {
        path: "/landing",
        name: "ceurLanding",
        component: () => import("./views/ceur/CeurLanding.vue")
      }
    ]
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

router.onError(error => {
  if (error.name === "ChunkLoadError" || /Loading chunk \d+ failed/g.test(error.message)) {
    window.location.reload();
  }
});

export default router;
